import templateUrl from 'servicestack/auto-query/auto-query-number-filter.htm';

const component  = {
    bindings: {
        filter: '<',
        icon: '@'
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default component;